import _ from 'lodash';
import {getPathDetails} from '../../ducks/formattersettingshelpers';

export function buildFilterSpecification(entityType, filterFormatters, filters) {
    let res = [];

    for (let i = 0; i < filters.length; i++) {
        let filter = filters[i];

        let filterFormatter = _.find(filterFormatters, {id: filter.id});
        if (filterFormatter && filterFormatter.attributePath) {
            let {pathName: attributeName} = getPathDetails(entityType, filterFormatter.attributePath);

            let comparisonType = filter.comparisonType || filterFormatter.comparisonType || 'EQ';

            if ((comparisonType === 'IN' || comparisonType === 'NIN') && _.isEmpty(filter.value)) {
                // For the IN an NIN operator, it doesn't make sense to apply the filter if nothing is selected
                continue;
            }

            let val = _.isArray(filter.value) ? filter.value.join(',') : filter.value;
            res.push(`${attributeName}[${comparisonType}]:${val}`);
        }
    }

    return res.join('+');
}
